import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Books from "../components/Books";
import { featuredChanged } from "../features/api/filterSlice";

export default function Home() {
  const { featured } = useSelector((state) => state.filter);
  const dispatch = useDispatch();

  const handleFeaturedChanged = (value) => {
    dispatch(featuredChanged(value));
  };
  return (
    <main className="py-12 px-6 2xl:px-6 container">
      <div className="order-2 xl:-order-1">
        <div className="flex items-center justify-between mb-12">
          <h4 className="mt-2 text-xl font-bold">Book List</h4>

          <div className="flex items-center space-x-4">
            <button
              onClick={() => handleFeaturedChanged(false)}
              className={`lws-filter-btn ${!featured && " active-filter"}`}
            >
              All
            </button>
            <button
              onClick={() => handleFeaturedChanged(true)}
              className={`lws-filter-btn ${featured && " active-filter"}`}
            >
              Featured
            </button>
          </div>
        </div>
        <Books />
      </div>
    </main>
  );
}
